import Box from '@cloudscape-design/components/box';
import Link from '@cloudscape-design/components/link';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useNavigate } from 'react-router-dom';
import { SearchTabs } from './SearchTabs';

const PageTitle = () => (
  <Box textAlign="center">
    <div style={{ marginBottom: 12 }}>
      <h1 style={{
        fontSize: '2.2rem',
        fontWeight: 700,
        margin: 0,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
        color: '#0f1b2a',
      }}>
        Beacon Lookup
      </h1>
    </div>
    <Box variant="p" fontSize="heading-s" color="text-body-secondary">
      End-to-end payment visibility across the last-mile pipeline
    </Box>
  </Box>
);

export const SearchPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 'calc(100vh - 56px)',
      paddingTop: '12vh',
      padding: '12vh 24px 0',
    }}>
      <div style={{ maxWidth: 760, width: '100%' }}>
        <SpaceBetween size="xl">
          <PageTitle />
          <SearchTabs />
          <Box textAlign="center">
            <Link
              href="/executions/by-status"
              onFollow={(e) => {
                e.preventDefault();
                navigate('/executions/by-status');
              }}
            >
              Or filter executions by status, state, or data source →
            </Link>
          </Box>
        </SpaceBetween>
      </div>
    </div>
  );
};
